import React from 'react';
import { t } from 'i18next';
import { add } from 'ionicons/icons';

import CustomButton from '~components/CustomButton';
import { ReactComponent as Stars } from '~assets/icons/stars.svg';
import { formatPrice } from '~utils/number';

import { useFreeProduct } from './hooks';
import styles from './styles.module.scss';

function FreeProduct() {
  const { product, amountRequired, canBeAdded, addProduct, loading, renderComponent } = useFreeProduct();
  const translationKey = canBeAdded ? 'getFreeProduct' : 'amountRequired';

  return renderComponent ? (
    <div className={styles.container}>
      <Stars className={styles.icon} />
      <p className={styles.description}>
        {t(`FreeProduct:${translationKey}.start`, { amount: formatPrice(amountRequired) })}
        <span className={styles.productName}>{product?.name}</span>
        {t(`FreeProduct:${translationKey}.end`)}
      </p>
      {canBeAdded && (
        <CustomButton
          className={styles.button}
          text={t('FreeProduct:addProduct')}
          icon={add}
          iconStyles={styles.ionIcon}
          btnClassType="secondary"
          type="button"
          onClick={addProduct}
          disabled={loading}
          textCapitalize
        />
      )}
    </div>
  ) : null;
}

export default FreeProduct;
